import { Component } from '@angular/core';
import { CloudResource } from '../../../decorators/cloud-resource';
import { TemplateDetailsComponent } from '../wizard-plugins/template-details/template-details.component';
import { UserAccountPluginComponent } from '../wizard-plugins/user-account-plugin/user-account-plugin.component';
@CloudResource({
  name: 'User Account',
  description: 'Manage user accounts and their permissions',
  plugins: [TemplateDetailsComponent, UserAccountPluginComponent],
  type:'acc',
  showOnResourceCreator: true
})
@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrl: './user-account.component.css'
})
export class UserAccountComponent {

}
